import { getDataUrl } from './functions';
import NeueMontreal_CSS from 'raw-loader!@/assets/fonts/NeueMontreal_CSS.txt'
import PPFormula_CSS from 'raw-loader!@/assets/fonts/PPFormula_CSS.txt'

const FONTS_MAP = {
  'NeueMontreal':NeueMontreal_CSS,
  'PPFormula':PPFormula_CSS
}

function copyStylesInline(destinationNode, sourceNode) {
  var containerElements = ["svg", "g"];
  for (var cd = 0; cd < destinationNode.childNodes.length; cd++) {
    var child = destinationNode.childNodes[cd];
    if (containerElements.indexOf(child.tagName) != -1) {
      copyStylesInline(child, sourceNode.childNodes[cd]);
      continue;
    }
    var style = sourceNode.childNodes[cd].currentStyle || window.getComputedStyle(sourceNode.childNodes[cd]);
    if (style == "undefined" || style == null) continue;
    for (var st = 0; st < style.length; st++) {
      child.style.setProperty(style[st], style.getPropertyValue(style[st]));
    }
  }
}

function triggerDownload(imgURI, fileName) {
  var evt = new MouseEvent("click", {
    view: window,
    bubbles: false,
    cancelable: true
  });
  var a = document.createElement("a");
  a.setAttribute("download", fileName);
  a.setAttribute("href", imgURI);
  a.setAttribute("target", '_blank');
  a.dispatchEvent(evt);
}

/*
  svg.getBBox() method allows us to determine the coordinates of the smallest rectangle
  in which the object fits. The coordinates returned are with respect to the current
  SVG space (after the application of all geometry attributes on all the elements
  contained in the target element)
  Thats why bbox is commented because on xAMaps when passes are rendered on the own field
  BBox height increase
*/
export function downloadPng(svg, fileName) {
  var copy = svg.cloneNode(true);
  copyStylesInline(copy, svg);
  var canvas = document.createElement("canvas");
  //var bbox = svg.getBBox();
  //canvas.width = (bbox.width ? bbox.width : svg.getAttribute('width')) * 2;
  //canvas.height = (bbox.height ? bbox.height : svg.getAttribute('height')) * 2;
  canvas.width = svg.getAttribute('width') * 2;
  canvas.height = svg.getAttribute('height') * 2;

  var ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  var data = (new XMLSerializer()).serializeToString(copy);

  //add name spaces.
  if(!data.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)){
    data = data.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
  }
  if(!data.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)){
    data = data.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
  }

  var DOMURL = window.URL || window.webkitURL || window;
  var img = new Image();
  var url = "data:image/svg+xml;utf-8," + encodeURIComponent(data);
  img.onload = function () {
    setTimeout(() => {
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
        var blob = canvas.msToBlob();
        navigator.msSaveOrOpenBlob(blob, fileName);
      }
      else {
        var imgURI = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        triggerDownload(imgURI, fileName);
      }
      DOMURL.revokeObjectURL(url);
    } ,100)
  };
  img.src = url;
}

export function exportSvg(svg, filename) {
  //get svg source.
  var serializer = new XMLSerializer();
  var source = serializer.serializeToString(svg);

  //add name spaces.
  if (!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
    source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
  }
  if (!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
    source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
  }

  //add xml declaration
  source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

  //convert svg source to URI data scheme.
  var url = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(source);

  //set url value to a element's href attribute.
  triggerDownload(url, filename);
  //you can download svg file by right click menu.
  return url;
}

export function exportSvgToFile(svg,filename){
  //get svg source.
  var serializer = new XMLSerializer();
  var source = serializer.serializeToString(svg);

  //add name spaces.
  if (!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
    source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
  }
  if (!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
    source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
  }

  //add xml declaration
  source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

  let blob = new Blob([source], {type: 'image/svg+xml'});
  blob.lastModifiedDate = new Date();
  blob.filename = filename;

  return blob;
}


export function getSVGString(svgNode) {
  var copy = svgNode.cloneNode(true);
  copyStylesInline(copy, svgNode);
  var serializer = new XMLSerializer();
  var svgString = serializer.serializeToString(copy);
  svgString = normalizeFractions(svgString);
  return svgString;
}

function normalizeFractions(svgString) {
  const map = {
    '\u2153': '1/3', // ⅓
    '\u2154': '2/3'  // ⅔
  };
  return svgString.replace(/[\u2153\u2154]/g, ch => map[ch]);
}


export async function generateSocialMediaSVG(size, textColor, bgColor,logoCfg = "none") {
  const scale = d3.scale.linear()
    .range([0.86, 0.92])
    .domain([650, 1000]);
  let SVG_WIDTH = size;
  let SVG_HEIGHT = 50;

  var svg = d3.select(document.createElement("div")).append("svg")
    .attr("width", SVG_WIDTH)
    .attr("height", SVG_HEIGHT)
    .style("fill", textColor)
    .style("background", bgColor)
    .attr("class", "driblabSocialMedia")

  //INI --- DRAW
  const SPACING_OFFSET = 10;
  const LOGO_SIZE = 32;
  const LOGO_Y = SVG_HEIGHT / 2;
  const LOGO_X = 20;
  await drawImageBase64(svg, LOGO_X, LOGO_Y, LOGO_SIZE, LOGO_SIZE, require("@/assets/img/black_x.png"), "", "twitterImg1")
  let twitterText1 = drawText(svg, LOGO_X + (LOGO_SIZE / 2) + 3, LOGO_Y, textColor, 16, "100", "@driblab", "left");

  // let twitter2X = LOGO_X + (LOGO_SIZE * 3.60);
  // await drawImageBase64(svg, twitter2X, LOGO_Y, LOGO_SIZE, LOGO_SIZE, require("@/assets/img/black_x.png"), "", "twitterImg2");
  let twitterText2 = drawText(svg, twitter2X + (LOGO_SIZE / 2) + 3, LOGO_Y + (FONT_SIZE * 1.2), textColor, 16, "100", "@DriblabES", "left")

  let instaX = SPACING_OFFSET + twitterText2[0][0].getBoundingClientRect().width + (LOGO_SIZE * 3);
  await drawImageBase64(svg, instaX, LOGO_Y, LOGO_SIZE, LOGO_SIZE, require("@/assets/img/insta.png"), "", "instaImg");

  if(logoCfg != "none"){
    const logoWidth = SVG_WIDTH * 0.22;
    const logoHeight = LOGO_SIZE + 10;
    await drawImageBase64(svg,SVG_WIDTH - (logoWidth/2) + 10,LOGO_Y - 5,logoWidth,logoHeight,
      require(logoCfg === 'white' ? "@/assets/img/driblab_normal_white.png" : "@/assets/img/driblab_normal_color.png"),"",`DriblabLogo|${logoCfg}`)
  }
  return svg;

}


export function drawImageBase64(svg, x, y, width, height, img, className, idName, bottom = false, extraParams = {}) {
  return new Promise((resolve) => {
    let base_image = new Image();
    base_image.crossOrigin = "anonymous";
    base_image.src = img;
    base_image.onload = (event) => {
      const dataUrl = getDataUrl(event.currentTarget);
      drawImage(
        svg,
        x,
        y,
        width,
        height,
        dataUrl,
        className,
        idName,
        bottom,
        extraParams
      );
      resolve(true);
    }
  })
}
export function drawImage(svg, x, y, width, height, img, className, idName, bottom = false, extraParams = {}) {
  let imgNode = bottom ? svg.insert("svg:image", ":first-child") : svg.append("svg:image");
  imgNode.attr("x", x - (width / 2))
    .attr("y", y - (height / 2))
    .attr("width", width)
    .attr("height", height)
    .attr("xlink:href", img)
    .attr("class", className)
  _.forEach(extraParams, (value, key) => {
    imgNode.attr(key, value);
  })
}
export function drawRectangle(svg, x, y, width, height, color, opacity, className) {
  svg.append("rect")
    .attr("class", className)
    .attr("x", x)
    .attr("y", y)
    .attr("width", width)
    .attr("height", height)
    .style("fill", color)
    .style("opacity", opacity);
}
export function drawLine(svg, x, y, distance, size, color, opacity, className) {
  svg.append('line')
    .attr("class", className)
    .style("stroke", color)
    .style("stroke-width", size)
    .attr("x1", x - (distance / 2))
    .attr("y1", y)
    .attr("x2", x + (distance / 2))
    .attr("y2", y)
    .style("opacity", opacity);
}
export function drawCircle(svg, x, y, radius, fillColor, borderColor, borderSize, opacity, className) {
  return svg.append("circle")
    .attr("class", className)
    .attr("r", radius)
    .attr("cx", x)
    .attr("cy", y)
    .style("fill", fillColor)
    .style("stroke", borderColor)
    .style("stroke-width", borderSize)
    .style("opacity", opacity);
}
export function drawText(svg, x, y, color, fontSize, fontWeight, text, anchor = "middle") {
  return svg.append("text")
    .attr("x", x)
    .attr("y", y)
    .attr("fill", color)
    .attr("font-size", fontSize)
    .attr("font-family", "NeueMontreal")
    .attr("font-weight", fontWeight)
    .style("text-anchor", anchor)
    .text(text);
}
export function copyAndAppendElement(parent,target,x,y){
    let copy = target.cloneNode(true);
    copy.setAttribute("x",x)
    copy.setAttribute("y",y)
    parent.appendChild(copy);
    return parent;
}

export function loadFonts(font = "NeueMontreal") {
  return new Promise((resolve) => {
    let css = FONTS_MAP[font];
    let out = d3.select(document.createElement("div")).append("svg").append('defs')
                  .append('style')
                  .attr('type', 'text/css')
                  .text(css);

    resolve(out);
  })
}


export function cloneCanvas(oldCanvas) {

    //create a new canvas
    var newCanvas = document.createElement('canvas');
    var context = newCanvas.getContext('2d');
    //set dimensions
    newCanvas.width = oldCanvas.width;
    newCanvas.height = oldCanvas.height;
    //apply the old canvas to the new one
    context.drawImage(oldCanvas, 0, 0);
    //return the new canvas
    return newCanvas;
}



// WEBPACK FOOTER //
// ./src/utils/exportToPNG.js